exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.in[data-v-2c008465] {\n    display: block;\n}\n.products-table[data-v-2c008465] {\n    font-size: 13px;\n}\n", ""]);

// exports
